import React from "react";
import { formatPrice } from "../utils/format";
import CartItem from "./CartItem";

const CartPanel = ({
    cart,
    cartCount,
    cartTotal,
    cartItemPrice,
    onUpdateQuantity,
    onRemove,
    onSubmit,
    submitting,
    dealId,
}) => (
    <aside className="pc-cart-panel">
        <div className="pc-cart-header">
            <h5>Корзина</h5>
            {cartCount > 0 && <span className="pc-cart-count">{cartCount}</span>}
        </div>
        <div className="pc-cart-body">
            {cart.length === 0 ? (
                <div className="pc-cart-empty">Корзина пуста</div>
            ) : (
                <>
                    {cart.map((item) => (
                        <CartItem
                            key={item.key}
                            item={item}
                            price={cartItemPrice(item)}
                            onUpdateQuantity={(value) => onUpdateQuantity(item.key, value)}
                            onRemove={() => onRemove(item.key)}
                        />
                    ))}
                    <div className="pc-cart-total">
                        <span>Итого</span>
                        <span>{formatPrice(cartTotal)} ₽</span>
                    </div>
                </>
            )}
        </div>
        <div className="pc-cart-footer">
            <button className="pc-submit-btn" disabled={cart.length === 0 || submitting} onClick={onSubmit}>
                {submitting ? "Добавляем..." : "Добавить в сделку"}
            </button>
            {!dealId && (
                <div className="pc-cart-hint">Страница открыта вне карточки сделки — добавление в сделку недоступно.</div>
            )}
        </div>
    </aside>
);

export default CartPanel;
